import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService_FacilitySetup } from "../data.service";

@Component({
	selector: "caass-siteadmin-facility-ms-visitor-pass",
	templateUrl: "./siteadmin-facility-ms-visitor-pass.component.html",
	styleUrls: ["./siteadmin-facility-ms-visitor-pass.component.css"],
})
export class SiteadminFacilityMsVisitorPassComponent implements OnInit {
	constructor(private facilityService: DataService_FacilitySetup) {}

	ngOnInit(): void {
		this.loadVisitorPassTemplates();

		this.UpdateFromMain();
	}

	ngOnChanges() {
		this.UpdateFromMain();
	}

	UpdateFromMain() {
		if (this.DefaultPassIDFromMain != undefined) {
			this.DefaultPassID = this.DefaultPassIDFromMain;
		}
		if (this.OffenderHitPassIDFromMain != undefined) {
			this.OffenderHitPassID = this.OffenderHitPassIDFromMain;
		}
		if (this.VerificationPassIDFromMain != undefined) {
			this.VerificationPassID = this.VerificationPassIDFromMain;
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	@Input() Saving: any = false;

	@Output() Finished: EventEmitter<any> = new EventEmitter();

	@Input() DefaultPassIDFromMain: any;
	@Input() OffenderHitPassIDFromMain: any;
	@Input() VerificationPassIDFromMain: any;
	@Input() FacilityIDFromMain: any = [];
	@Input() EditMode: any = false;

	//Form data
	DefaultPassID: any = 0;
	OffenderHitPassID: any = 0;
	VerificationPassID: any = 0;
	lstPassTemplate: any = [];

	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	loadVisitorPassTemplates() {
		var result = this.facilityService.loadMSIDCardTemplates(this.FacilityIDFromMain);
		result.subscribe(
			(response) => {
				this.lstPassTemplate = response;

				this.lstPassTemplate.unshift({
					IDCardTemplateID: "-1",
					CardName: "None",
				});

				this.DefaultPassID = this.lstPassTemplate[0].IDCardTemplateID;
				this.OffenderHitPassID = this.lstPassTemplate[0].IDCardTemplateID;
				this.VerificationPassID = this.lstPassTemplate[0].IDCardTemplateID;

				if (this.DefaultPassIDFromMain != undefined && this.DefaultPassIDFromMain != "") {
					this.DefaultPassID = this.DefaultPassIDFromMain;
				}
				if (this.OffenderHitPassIDFromMain != undefined && this.OffenderHitPassIDFromMain != "") {
					this.OffenderHitPassID = this.OffenderHitPassIDFromMain;
				}
				if (this.VerificationPassIDFromMain != undefined && this.VerificationPassIDFromMain != "") {
					this.VerificationPassID = this.VerificationPassIDFromMain;
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onNext() {
		let myData: any = {
			DefaultPassID: this.DefaultPassID,
			OffenderHitPassID: this.OffenderHitPassID,
			VerificationPassID: this.VerificationPassID,
		};

		this.Finished.emit(myData);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////
	GetFinishText() {
		if (this.EditMode == true) {
			return "Update Facility";
		} else {
			return "Finish";
		}
	}
	///////////////////////////////////////////////////////
}
